export default __webpack_public_path__ + "static/media/temp_card.53c7a5ad.svg";